module.exports = __webpack_public_path__ + "img/product12_2.16210bd2.png";